import {
  PrimaryButton,
  Label,
  Stack,
  StackItem,
  DetailsListLayoutMode,
  SelectionMode,
  IColumn,
  SearchBox,
  IconButton,
  Icon,
  mergeStyles,
  Pivot,
  PivotItem,
  StickyPositionType,
  Sticky,
  MessageBar,
  MessageBarType,
  Modal,
  mergeStyleSets,
  TooltipHost,
  ITooltipHostStyles,
} from "@fluentui/react";

import React, { useEffect, useMemo, useState } from "react";
import styles from "./home.module.scss";
import stylesNewProject from "../newProject/newProject.module.scss";
import { useNavigate } from "react-router-dom";
import { IProject } from "../../../common/models/IProject";
import ProjectService from "../../../common/api-services/ProjectServices";
import Pagination from "../../common/pagination/Pagination";
import ResizableDetailsList from "../../common/resizableDetailsList/ResizableDetailsList";
import { useBoolean, useId } from "@fluentui/react-hooks";
import CommonService from "../../../common/api-services/CommonService";
import { IAzureUserInformation } from "../../../common/models/IUserDetails";
import GraphService from "../../../common/authProvider/GraphService";
import PermissionService from "../../../common/api-services/PermissionService";
import { getDomainAcceptance } from "../../../common/utils/recipientDomains";
import { categories } from "../newProject/newProject";

const Home: React.FC = () => {
  const [projects, setProjects] = useState<IProject[]>([]);
  const [currentUser, setCurrentUser] = useState<IAzureUserInformation>();
  const [projectsFiltred, setProjectsFiltred] = useState<IProject[]>([]);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize] = useState<number>(10);
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [sortedColumn, setSortedColumn] = useState<{
    name: string;
    isDescending: boolean;
  } | null>(null);
  const [projectIdToDelete, setProjectIdToDelete] = useState<string>("");
  const [projectToArchive, setProjectToArchive] = useState<IProject>();
  const [projectToReactivate, setProjectToReactive] = useState<IProject>();
  const [modalText, setModalText] = useState<string>("");
  const [deleteModalAction, isDeleteModalAction] = useState<boolean>(true);
  const service = useMemo(() => new ProjectService(), []);
  const serviceCommon = useMemo(() => new CommonService(), []);
  const [message, setMessage] = useState<string>("");
  const [messageBarType, setMessageBarType] = useState<MessageBarType>();
  const [isModalOpen, { setTrue: showModal, setFalse: hideModal }] =
    useBoolean(false);
  const [
    isLoadingProjects,
    { setTrue: startLoadingProjects, setFalse: stopLoadingProjects },
  ] = useBoolean(true);
  const [searchValue, setSearchValue] = useState("");
  const calloutProps = { gapSpace: 0 };
  const tooltipArchiveId = useId("tooltipArchiveProject");
  const hostStyles: Partial<ITooltipHostStyles> = {
    root: { display: "inline-block" },
  };
  const iconClass = mergeStyles({
    fontSize: 16,
    height: 24,
    width: 24,
    color: "green",
  });
  let navigate = useNavigate();
  const routeChange = () => {
    let path = `/project`;
    navigate(path);
  };
  const _onFormatDate = (date: string): string => {
    const myDate = new Date(date);

    return (
      ("0" + myDate.getDate()).slice(-2) +
      "." +
      ("0" + (myDate.getMonth() + 1)).slice(-2) +
      "." +
      myDate.getFullYear()
    );
  };
  const onColumnClick = (_: any, cl: IColumn) => {
    if (sortedColumn && sortedColumn.name === cl.fieldName) {
      setSortedColumn({
        isDescending: !sortedColumn.isDescending,
        name: cl.fieldName || "",
      });
    } else {
      setSortedColumn({
        isDescending: false,
        name: cl.fieldName || "",
      });
    }
  };

  const columns: IColumn[] = [
    {
      key: "column1",
      name: "Created",
      fieldName: "createdDate",
      isRowHeader: true,
      minWidth: 70,
      maxWidth: 70,
      onColumnClick: onColumnClick,
      isSorted: !!sortedColumn && sortedColumn.name === "createdDate",
      isSortedDescending: !!sortedColumn && sortedColumn.isDescending,
      onRender: (item: any) => {
        return _onFormatDate(item.createdDate);
      },
    },
    {
      key: "column10",
      name: "Status",
      fieldName: "status",
      minWidth: 50,
      maxWidth: 80,
      onRender: (item: any) => {
        return (
          <Stack horizontalAlign="start" style={{ minWidth: 100 }}>
            {item.status == "Archived" && (
              <Label disabled className={styles.Archived}>
                {item.status}
              </Label>
            )}
            {item.status == "Active" && (
              <Label disabled className={styles.Active}>
                {item.status}
              </Label>
            )}
            {item.status == "Draft" && (
              <Label disabled className={styles.Draft}>
                {item.status}
              </Label>
            )}
          </Stack>
        );
      },
    },
    {
      key: "column2",
      name: "Project",
      fieldName: "name",
      minWidth: 80,
      maxWidth: 150,
      isRowHeader: true,
      isResizable: true,
      data: "string",
      onColumnClick: onColumnClick,
      isSorted: !!sortedColumn && sortedColumn.name === "name",
      isSortedDescending: !!sortedColumn && sortedColumn.isDescending,
    },
    {
      key: "column3",
      name: "Category",
      fieldName: "category",
      minWidth: 120,
      maxWidth: 180,
      isRowHeader: true,
      data: "string",
      isPadded: false,
      onRender: (item) =>
        categories.find((c) => c.key === item.category)?.text || item.category,
      onColumnClick: onColumnClick,
      isSorted: !!sortedColumn && sortedColumn.name === "category",
      isSortedDescending: !!sortedColumn && sortedColumn.isDescending,
    },
    {
      key: "column4",
      name: "Roland Berger entity",
      fieldName: "company",
      minWidth: 100,
      maxWidth: 200,
      isRowHeader: true,

      data: "string",
      isPadded: false,
      onColumnClick: onColumnClick,
      isSorted: !!sortedColumn && sortedColumn.name === "company",
      isSortedDescending: !!sortedColumn && sortedColumn.isDescending,
    },
    {
      key: "column5",
      name: "Client",
      fieldName: "client",
      minWidth: 80,
      maxWidth: 150,
      isRowHeader: true,
      data: "string",
      isPadded: false,
      onColumnClick: onColumnClick,
      isSorted: !!sortedColumn && sortedColumn.name === "client",
      isSortedDescending: !!sortedColumn && sortedColumn.isDescending,
    },
    {
      key: "column6",
      name: "Target",
      fieldName: "target",
      minWidth: 100,
      maxWidth: 200,
      isRowHeader: true,
      isResizable: true,
      data: "string",
      isPadded: false,
      onColumnClick: onColumnClick,
      isSorted: !!sortedColumn && sortedColumn.name === "target",
      isSortedDescending: !!sortedColumn && sortedColumn.isDescending,
    },
    {
      key: "column7",
      name: "Acceptance status",
      fieldName: "statistics",
      minWidth: 100,
      maxWidth: 250,
      isRowHeader: true,
      data: "string",
      isPadded: false,
      onRender: (item: any) => {
        const { accepted, total } = getDomainAcceptance(item.recipients);

        // let downloadedItem = item.recipients
        //   ? item.recipients
        //       .filter((e: any) => {
        //         return !e.isDeleted;
        //       })
        //       .filter((e: any) => {
        //         if (e.documents != null) {
        //           return e.documents.some(
        //             (x: IReportDocument) => x.isDownloaded
        //           );
        //         } else {
        //           return false;
        //         }
        //       }).length
        //   : 0;
        // let strDownloaded = `${downloadedItem} /${
        //   item.recipients
        //     ? item.recipients.filter((e: any) => {
        //         return !e.isDeleted;
        //       }).length
        //     : 0
        // }`;
        return (
          <Stack horizontal horizontalAlign="start">
            <TooltipHost
              content="Domains with at least one terms acceptance / all recipient domains"
              // This id is used on the tooltip itself, not the host
              // (so an element with this id only exists when the tooltip is shown)
              // id={tooltipArchiveId}
              calloutProps={calloutProps}
              styles={hostStyles}
            >
              <Icon iconName="CompletedIcon" className={iconClass} />
            </TooltipHost>

            <Label style={{ paddingTop: 3, fontWeight: 400 }}>
              {`${accepted}/${total}`}
            </Label>
            {/* <TooltipHost
              content="Report downloaded"
              // This id is used on the tooltip itself, not the host
              // (so an element with this id only exists when the tooltip is shown)
              // id={tooltipArchiveId}
              calloutProps={calloutProps}
              styles={hostStyles}
            >
              <Icon iconName="DownloadIcon" className={iconClass} />
            </TooltipHost>
            <Label style={{ paddingTop: 3, fontWeight: 400 }}>
              {strDownloaded}
            </Label> */}
          </Stack>
        );
      },
    },
    {
      key: "column8",
      name: "",
      fieldName: "",
      minWidth: 100,
      maxWidth: 100,
      isRowHeader: true,
      data: "string",
      isPadded: false,
      onRender: (item: any) => {
        return (
          <Stack horizontal horizontalAlign="end">
            <TooltipHost
              content="Edit/View project details"
              // This id is used on the tooltip itself, not the host
              // (so an element with this id only exists when the tooltip is shown)
              // id={tooltipArchiveId}
              calloutProps={calloutProps}
              styles={hostStyles}
            >
              <IconButton
                iconProps={{ iconName: "Edit" }}
                text=""
                label="Edit"
                onClick={() => {
                  navigate(`/project/${item.projectId}`);
                }}
                className={styles.actionIconButton}
                alt="Edit Project"
              />
            </TooltipHost>
            {item.status == "Archived" &&
              (item.owner?.includes(currentUser?.email) ||
                item.contributor?.includes(currentUser?.email)) && (
                <TooltipHost
                  content="Reactivate project"
                  // This id is used on the tooltip itself, not the host
                  // (so an element with this id only exists when the tooltip is shown)
                  // id={tooltipArchiveId}
                  calloutProps={calloutProps}
                  styles={hostStyles}
                >
                  <IconButton
                    iconProps={{
                      iconName: "PlaybackRate1xIcon",
                      styles: {
                        root: [
                          {
                            selectors: {
                              ">span": {
                                verticalAlign: "top",
                              },
                            },
                          },
                        ],
                      },
                    }}
                    text=""
                    onClick={() => {
                      isDeleteModalAction(false);
                      setProjectToReactive(item);
                      setModalText(
                        "You are about to reactivate this project. Please confirm to proceed",
                      );
                      showModal();
                    }}
                    className={styles.actionIconButton}
                  />
                </TooltipHost>
              )}
            {item.status == "Active" &&
              (item.owner?.includes(currentUser?.email) ||
                item.contributor?.includes(currentUser?.email)) && (
                <TooltipHost
                  content="Archive project"
                  // This id is used on the tooltip itself, not the host
                  // (so an element with this id only exists when the tooltip is shown)
                  id={tooltipArchiveId}
                  calloutProps={calloutProps}
                  styles={hostStyles}
                >
                  <IconButton
                    iconProps={{
                      iconName: "ArchiveIcon",
                      styles: {
                        root: [
                          {
                            selectors: {
                              ">span": {
                                verticalAlign: "top",
                              },
                            },
                          },
                        ],
                      },
                    }}
                    onClick={() => {
                      isDeleteModalAction(false);
                      setProjectToArchive(item);
                      setModalText(
                        "You are about to archive this project. Please confirm to proceed",
                      );
                      showModal();
                    }}
                    className={styles.actionIconButton}
                    aria-describedby={tooltipArchiveId}
                  />
                </TooltipHost>
              )}
            {item.status == "Draft" &&
              (item.owner?.includes(currentUser?.email) ||
                item.contributor?.includes(currentUser?.email)) && (
                <TooltipHost
                  content="Delete project"
                  // This id is used on the tooltip itself, not the host
                  // (so an element with this id only exists when the tooltip is shown)
                  // id={tooltipArchiveId}
                  calloutProps={calloutProps}
                  styles={hostStyles}
                >
                  <IconButton
                    iconProps={{ iconName: "Delete" }}
                    text=""
                    label="Delete"
                    onClick={() => {
                      isDeleteModalAction(true);
                      setProjectIdToDelete(item.projectId);
                      setModalText(
                        "You are about to delete this project. Please confirm to proceed",
                      );
                      showModal();
                    }}
                    className={styles.actionIconButton}
                  />
                </TooltipHost>
              )}
          </Stack>
        );
      },
    },
  ];

  const getProjects = () => {
    startLoadingProjects();
    service
      .GetAll()
      .then((result: any) => {
        if (result) {
          setProjects(result);
        }
      })
      .finally(() => {
        stopLoadingProjects();
      });
  };

  const filterProject = () => {
    if (projects.length > 0) {
      let searchFiltred: IProject[] = [];
      if (searchValue != "") {
        searchFiltred = projects.filter((data) => {
          return (
            data.company.toLowerCase().includes(searchValue) ||
            data.target.toLowerCase().includes(searchValue) ||
            data.client.toLowerCase().includes(searchValue) ||
            data.name.toLowerCase().includes(searchValue) ||
            data.category.toLowerCase().includes(searchValue)
          );
        });
      } else {
        searchFiltred = [...projects];
      }

      if (sortedColumn) {
        const { name, isDescending } = sortedColumn;
        searchFiltred = searchFiltred.sort((a, b) => {
          // "Created" is a date - compare chronologically, not as a string.
          if (name === "createdDate") {
            const aTime = new Date(a.createdDate as any).getTime() || 0;
            const bTime = new Date(b.createdDate as any).getTime() || 0;
            return isDescending ? bTime - aTime : aTime - bTime;
          }
          const aVal = (a[name as keyof IProject] as string) || "";
          const bVal = (b[name as keyof IProject] as string) || "";
          return isDescending
            ? bVal.localeCompare(aVal, undefined, { sensitivity: "base" })
            : aVal.localeCompare(bVal, undefined, { sensitivity: "base" });
        });
      }

      if (statusFilter != "") {
        let result = searchFiltred.filter((data) => {
          return data.status == statusFilter;
        });
        if (result.length < pageSize) {
          setTotalPages(1);
        } else {
          setTotalPages(Math.ceil(result.length / pageSize));
        }
        setProjectsFiltred([
          ...result.slice((currentPage - 1) * pageSize, currentPage * pageSize),
        ]);
      } else {
        if (searchFiltred.length < pageSize) {
          setTotalPages(1);
          setProjectsFiltred([...searchFiltred]);
        } else {
          setTotalPages(Math.ceil(searchFiltred.length / pageSize));
          setProjectsFiltred([
            ...searchFiltred.slice(
              (currentPage - 1) * pageSize,
              currentPage * pageSize,
            ),
          ]);
        }
      }
    }
  };
  const handleLinkClick = (item?: PivotItem) => {
    setCurrentPage(1);
    if (item?.props.itemKey) {
      setStatusFilter(item?.props.itemKey);
    } else {
      setStatusFilter("");
    }
  };
  const changeCurrentPage = (newPageNumber: number) => {
    setCurrentPage(newPageNumber);
  };
  const onDeleteProject = () => {
    if (projectIdToDelete != "") {
      service.Delete(projectIdToDelete).then((result: any) => {
        if (result?.error) {
          setMessage(`Error: ${result?.error}`);
          setMessageBarType(MessageBarType.error);
        } else {
          setMessage(`Project deleted successfully`);
          setMessageBarType(MessageBarType.success);
          resetModal();
          getProjects();
        }
      });
    }
  };
  const onArchiveProject = () => {
    if (
      projectToArchive?.status != "Archived" &&
      projectToArchive != undefined &&
      projectToArchive.projectId
    ) {
      service.GetById(projectToArchive.projectId).then((result: any) => {
        if (result?.error) {
          setMessage(`Error: ${result?.error}`);
          setMessageBarType(MessageBarType.error);
        } else {
          projectToArchive.status = "Archived";
          let obj: IProject;
          obj = JSON.parse(JSON.stringify(projectToArchive));
          obj.company = result.company;

          service.Update(obj as IProject).then((result: any) => {
            if (result?.error) {
              setMessage(`Error: ${result?.error}`);
              setMessageBarType(MessageBarType.error);
            } else {
              setMessage(`Project archived successfully`);
              setMessageBarType(MessageBarType.success);
              resetModal();
              getProjects();
            }
          });
        }
      });
    }
  };
  const onReactivateProject = () => {
    if (
      projectToReactivate?.status == "Archived" &&
      projectToReactivate != undefined &&
      projectToReactivate.projectId
    ) {
      projectToReactivate.status = "Active";
      service.GetById(projectToReactivate.projectId).then((result: any) => {
        if (result?.error) {
          setMessage(`Error: ${result?.error}`);
          setMessageBarType(MessageBarType.error);
        } else {
          let obj: IProject;
          obj = JSON.parse(JSON.stringify(projectToReactivate));
          obj.company = result.company;

          service.Update(obj as IProject).then((result: any) => {
            if (result?.error) {
              setMessage(`Error: ${result?.error}`);
              setMessageBarType(MessageBarType.error);
            } else {
              setMessage(`Project reactivated successfully`);
              setMessageBarType(MessageBarType.success);
              resetModal();
              getProjects();
            }
          });
        }
      });
    }
  };
  const contentStyles = mergeStyleSets({
    container: {
      display: "flex",
      flexFlow: "column nowrap",
      alignItems: "stretch",
      border: "1px solid",
      minHeight: "120px",
      minWidth: "250px",
      borderRadius: "25px",
    },
  });
  const resetModal = () => {
    setProjectIdToDelete("");
    setProjectToArchive(undefined);
    setProjectToReactive(undefined);
    hideModal();
  };
  useEffect(() => {
    // Load cached user immediately for UI state
    const localCurrentUser = localStorage.getItem("currentUser");
    if (typeof localCurrentUser === "string") {
      setCurrentUser(JSON.parse(localCurrentUser));
    }

    // Fetch fresh role info first, then load projects so role headers are included
    const graphService = new GraphService();
    const permService = new PermissionService();
    graphService.getAzureCurrentUser().then((userData) => {
      permService.GetByUserEmail(userData.email).then((result: any) => {
        if (!result?.error && result != null) {
          userData.isAdmin = result.isAdmin;
          userData.isLegal = result.isLegal;
          userData.isProjectManager = result.isProjectManager;
        } else {
          userData.isAdmin = false;
          userData.isLegal = false;
          userData.isProjectManager = false;
        }
        setCurrentUser(userData);
        localStorage.setItem("currentUser", JSON.stringify(userData));
        getProjects();
      });
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    filterProject();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, statusFilter, projects, searchValue, sortedColumn]);

  const downloadFile = (blob: Blob, fileName: string, type: string) => {
    const data = new Blob([blob], { type });
    const file = window.URL.createObjectURL(data);
    const tempLink = document.createElement("a");
    tempLink.href = file;
    tempLink.setAttribute("download", `${fileName}`);
    tempLink.click();
  };
  const onUserManulButtonClick = () => {
    serviceCommon.GetUserManual().then((result: any) => {
      if (result?.userManualData) {
        fetch(`data:application/pdf;base64,${result.userManualData}`)
          .then((res) => res.blob())
          .then((blob) => {
            downloadFile(blob, result.userManualFilename ?? "User manual.pdf", "application/pdf");
          });
      }
    });
  };

  return (
    <>
      <Stack verticalAlign="start">
        <Stack horizontalAlign="space-between" horizontal>
          <StackItem align="start">
            <Label className={styles.PageHeader}>Project list</Label>
          </StackItem>
          <StackItem align="end">
            <Stack horizontal tokens={{ childrenGap: 8 }}>
              <PrimaryButton
                text="User manual"
                className={styles.buttonNewProject}
                onClick={onUserManulButtonClick}
              />
            </Stack>
          </StackItem>
        </Stack>
        <StackItem>
          <hr className={styles.horizontalLine}></hr>
        </StackItem>
        {message != "" && (
          <Stack>
            <MessageBar
              messageBarType={messageBarType}
              isMultiline={false}
              dismissButtonAriaLabel="Close"
              onDismiss={() => {
                setMessage("");
                setMessageBarType(undefined);
              }}
            >
              {message}
            </MessageBar>
          </Stack>
        )}
        {
          <StackItem align="end">
            <PrimaryButton
              text="New project"
              className={styles.buttonNewProject}
              onClick={routeChange}
            />
          </StackItem>
        }
      </Stack>
      <Stack horizontal horizontalAlign="space-between">
        <Pivot onLinkClick={handleLinkClick}>
          <PivotItem headerText="Show all"> </PivotItem>
          <PivotItem headerText="Draft" itemKey="Draft">
            {" "}
          </PivotItem>
          <PivotItem headerText="Active" itemKey="Active">
            {" "}
          </PivotItem>
          <PivotItem headerText="Archived" itemKey="Archived">
            {" "}
          </PivotItem>
        </Pivot>
        <Stack horizontal>
          <SearchBox
            onSearch={(newValue) => {
              setSearchValue(newValue.toLowerCase());
            }}
            className={styles.searchBox}
            onClear={() => setSearchValue("")}
          />
        </Stack>
      </Stack>
      <Stack>
        <StackItem>
          <ResizableDetailsList
            items={[...projectsFiltred]}
            enableShimmer={isLoadingProjects}
            compact={false}
            columns={columns}
            selectionMode={SelectionMode.none}
            setKey="set"
            getKey={(it, index) => it?.projectId ?? String(index)}
            key="projectsList"
            layoutMode={DetailsListLayoutMode.justified}
            isHeaderVisible={true}
          />
        </StackItem>
        <Sticky stickyPosition={StickyPositionType.Footer}>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onChange={changeCurrentPage}
          />
        </Sticky>
      </Stack>
      <Modal
        isOpen={isModalOpen}
        onDismiss={resetModal}
        isBlocking={false}
        containerClassName={contentStyles.container}
      >
        <Stack style={{ padding: 20 }}>
          <Label className={stylesNewProject.contentHeader}>{modalText}</Label>

          <Stack horizontal horizontalAlign="end">
            <PrimaryButton
              text="Confirm"
              className={stylesNewProject.buttonSave}
              disabled={false}
              onClick={
                deleteModalAction
                  ? onDeleteProject
                  : projectToReactivate
                    ? onReactivateProject
                    : onArchiveProject
              }
            />
            <PrimaryButton
              text="Cancel"
              className={stylesNewProject.buttonCancel}
              onClick={resetModal}
            />
          </Stack>
        </Stack>
      </Modal>
    </>
  );
};
export default Home;
